import { call, put } from 'redux-saga/effects';
import bugsnagClient from '../../../../services/bugsnag/bugsnag';
import { fetchAnalyticTeamAction } from '../../analyticTeam/fetchTeam/action';
import { fetchAnalyticTeamDataAction } from '../../analyticData/fetchTeamData/action';
import { showSnackbar } from '../../../../state/snackbar/snackbarSlice';
import { backendClient } from '../../../../services/api/backend-client';

export function* removeTeamMemberSaga(action) {
    const { teamId, uids = [] } = action.payload || {};

    try {
        if (!teamId) throw new Error("teamId is required");
        if (!Array.isArray(uids) || uids.length === 0) {
            throw new Error("uids[] is required");
        }

        if (uids.length === 1) {
            yield call(
                [backendClient, backendClient.delete],
                `teams/${encodeURIComponent(teamId)}/members/${encodeURIComponent(uids[0])}`
            );
        } else {
            yield call(
                [backendClient, backendClient.delete],
                `teams/${encodeURIComponent(teamId)}/members/batch`,
                { data: { uids } }
            );
        }

        yield put(fetchAnalyticTeamAction());
        yield put(fetchAnalyticTeamDataAction({ teamId, range: 'week' }));

        yield put(showSnackbar({
            message: `Member${uids.length > 1 ? "s" : ""} removed successfully.`,
            severity: "success",
        }));
    } catch (err) {
        bugsnagClient.notify(err);
        console.error("Failed to remove analytic team member(s):", err?.message);
        yield put(showSnackbar({ message: "Failed to remove team member(s).", severity: "error" }));
    }
}